import React from 'react';

// --- FUNCIÓN AUXILIAR: Para extraer mensaje de forma segura ---
const extractMessage = (message) => {
  // Si es un elemento React válido (JSX), lo devolvemos tal como está
  if (React.isValidElement(message)) {
    return message;
  }
  
  // Si es un string, lo devolvemos tal como está
  if (typeof message === 'string') return message;
  
  // Si es un array (posiblemente elementos JSX), lo devolvemos tal como está
  if (Array.isArray(message)) return message;
  
  // Solo convertimos a string si es un objeto de error
  if (message?.message && typeof message.message === 'string') return message.message;
  if (message?.summary && typeof message.summary === 'string') return message.summary;
  if (message?.summary && typeof message.summary === 'object') {
    return message.summary.message || JSON.stringify(message.summary);
  }
  if (typeof message === 'object') {
    return JSON.stringify(message);
  }
  return 'Mensaje no válido';
};

const JobStatus = ({ job, onConfirm, onDismiss }) => {
  if (!job || !job.id) {
    return null;
  }

  const isProcessing = ['loading', 'processing'].includes(job.status);
  const isFinalState = ['completado', 'error'].includes(job.status);

  const getStatusClassName = () => {
    if (job.status === 'completado') return 'success';
    if (job.status === 'error') return 'error';
    if (['pending_confirmation', 'awaiting_confirmation'].includes(job.status)) return 'warning';
    return 'processing';
  };

  // Extraer el mensaje de forma segura
  const safeMessage = extractMessage(job.message);

  // --- NUEVO: Renderizar mensaje de confirmación con estructura completa ---
  const renderConfirmationMessage = () => {
    // Cambiar para reconocer tanto 'pending_confirmation' como 'awaiting_confirmation'
    if (!['pending_confirmation', 'awaiting_confirmation'].includes(job.status)) {
      return <div>{safeMessage}</div>;
    }

    // Si es un estado de confirmación, intentar extraer la información del summary
    let parsedInfo = null;
    try {
      // El backend envía: {summary: {new: X, updated: Y, deleted: Z}}
      if (typeof safeMessage === 'object' && safeMessage.summary) {
        parsedInfo = safeMessage.summary;
      } else if (typeof safeMessage === 'string' && safeMessage.includes('{')) {
        const parsed = JSON.parse(safeMessage);
        parsedInfo = parsed.summary || parsed;
      }
    } catch (e) {
      console.log('No se pudo parsear el mensaje de confirmación:', e);
    }

    return (
      <div className="confirmation-message">
        <h4>Confirmación de Actualización de Referencias</h4>
        {parsedInfo ? (
          <div className="update-summary">
            <p><strong>Referencias nuevas:</strong> {parsedInfo.new || 0}</p>
            <p><strong>Referencias actualizadas:</strong> {parsedInfo.updated || 0}</p>
            <p><strong>Referencias que se eliminarán:</strong> {parsedInfo.deleted || 0}</p>
          </div>
        ) : (
          <div className="update-summary">
            <p>{typeof safeMessage === 'string' ? safeMessage : JSON.stringify(safeMessage)}</p>
          </div>
        )}
        <div className="confirmation-buttons">
          <button onClick={() => onConfirm('approve')} className="approve">
            Confirmar (Sin Eliminar)
          </button>
          <button onClick={() => onConfirm('reject')} className="reject">
            Confirmar (Y Eliminar Obsoletas)
          </button>
        </div>
      </div>
    );
  };

  return (
    <div className={`job-status-banner ${getStatusClassName()}`}>
      {isProcessing && <div className="spinner-small"></div>}
      {renderConfirmationMessage()}
      {!isProcessing && !isFinalState && !['pending_confirmation', 'awaiting_confirmation'].includes(job.status) && (
        <button onClick={onDismiss} className="dismiss-button">&times;</button>
      )}
    </div>
  );
};

export default JobStatus;